import React, { useState, useEffect, useCallback, useRef } from 'react'
import ReactMapboxGl, { ZoomControl } from 'react-mapbox-gl'
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import { userLocation } from '../../../../lib/util'
import mapboxgl from 'mapbox-gl'

const MapBox = ReactMapboxGl({
  accessToken: process.env.REACT_APP_MAPBOX_TOKEN,
})

export default function ProjectDialogMap(props) {
  const [zoom, setZoom] = useState(13)
  const [marker, setMarker] = useState(null)
  const mapRef = useRef()
  const [_, forceUpdate] = useState(0)
  const map = mapRef.current

  useEffect(async () => {
    await userLocation()
      .then(location => {
        props.setCenter(location)
      })
      .catch(error => {
        console.error(error)
      })
  }, [])

  const handleMapLoaded = useCallback(
    map => {
      mapRef.current = map

      mapRef.current.on('zoomend', function (e) {
        if (e.originalEvent) {
          setZoom(mapRef.current.getZoom())
        }
      })

      let tmp = new mapboxgl.Marker({
        draggable: true,
      })
        .setLngLat(props.center)
        .addTo(mapRef.current)
      const onDragEnd = () => {
        const center = [tmp.getLngLat().lng, tmp.getLngLat().lat]
        props.setCenter(center)
      }
      tmp.on('dragend', onDragEnd)
      setMarker(tmp)

      forceUpdate(_ + 1)
    },
    [map]
  )

  useEffect(async () => {
    if (marker) {
      marker.setLngLat(props.center)
    }
  }, [props.center])

  return (
    <MapBox
      // eslint-disable-next-line
      style="mapbox://styles/mapbox/light-v9"
      containerStyle={{
        height: '100%',
      }}
      center={props.center}
      zoom={[zoom]}
      onStyleLoad={handleMapLoaded}
    >
      <div style={{ position: 'absolute', right: 0, bottom: 120 }}>
        <ZoomControl />
      </div>
    </MapBox>
  )
}
